export const URL = "/api";
export const API_CONTEXT_ROOT = URL; 

export const ENVIRONMENT_API_CONTEXT_ROOT = "/enviroment"; 
export const AUTHORIZATION_API_CONTEXT_ROOT = "/authorization"; 
export const TASK_MANAGEMENT_API_CONTEXT_ROOT = "/taskmgmt"; 

export const headers = {mode: 'cors',credentials: 'include'};

